import moment from 'moment';

import { get } from '../../Common/utils';

const dateFormatter = date =>
  moment.utc(date, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD h:mm:ss a');

const rejectedFactory = ({ visits = [] }) =>
  visits.map(visit => ({
    rejectedID: get(visit, 'id', ''),
    referenceNumber: get(visit, 'referenceNumber', ''),
    partnerID: get(visit, 'partnerID', ''),
    agencyID: get(visit, 'partnerAgencyID', ''),
    firstReceivedOn: dateFormatter(get(visit, 'firstReceivedOn', '')),
    lastReceivedOn: dateFormatter(get(visit, 'lastReceivedOn', '')),
    count: get(visit, 'count', 0),
    errorMessage: get(visit, 'errorMessage', ''),
  }));

const getRejectedTotalRecords = ({ totalRecords = 0 }) => totalRecords;

const normalizeRejects = response => ({
  rejects: rejectedFactory(response),
  totalRecords: getRejectedTotalRecords(response),
});

const normalizeRejectedDetails = (rejectedDetails = {}) => ({
  visitPayload: get(rejectedDetails, 'visitPayload', {}),
});

const normalizePartners = ({ partners = [] }) =>
  [{ label: 'All', value: 'ALL' }].concat(
    partners.map(agency => ({
      label: get(agency, 'name', ''),
      value: get(agency, 'partnerID', ''),
    })),
  );

const normalizeAgencies = ({ agencies = [] }) =>
  [{ label: 'All', value: 'ALL' }].concat(
    agencies.map(agency => ({
      label: get(agency, 'name', ''),
      value: get(agency, 'agencyID', ''),
    })),
  );

export { normalizeRejects, normalizeAgencies, normalizePartners, normalizeRejectedDetails };
